/**
 * RisksList Component
 * Displays risks identified in project documents.
 */

import React from 'react';
import { AlertTriangle } from 'lucide-react';
import type { Risk } from '@/services/projectAnalysisApi';
import { InsightCard } from './InsightCard';

interface RisksListProps {
  risks: Risk[];
}

export const RisksList: React.FC<RisksListProps> = ({ risks }) => {
  if (risks.length === 0) {
    return (
      <div className="text-center py-8 text-slate-500">
        <AlertTriangle className="w-12 h-12 mx-auto mb-3 text-slate-300" />
        <p>No risks identified in your documents.</p>
        <p className="text-sm mt-1">Risks and mitigations will appear here.</p>
      </div>
    );
  }

  // Sort by severity (critical first)
  const severityOrder = { critical: 0, high: 1, medium: 2, low: 3 };
  const sorted = [...risks].sort(
    (a, b) => (severityOrder[a.severity] ?? 3) - (severityOrder[b.severity] ?? 3)
  );

  return (
    <div className="space-y-3">
      {sorted.map((risk, index) => (
        <InsightCard
          key={index}
          type="risk"
          title={risk.risk}
          source={risk.source}
          severity={risk.severity}
          mitigation={risk.mitigation}
        />
      ))}
    </div>
  );
};

export default RisksList;
